import { useId, useRef, useState } from 'react';
import { Button, CloseButton, Figure, FigureCaption, Image, Modal } from 'react-bootstrap';
import CloseIcon from '@mui/icons-material/Close';
import { ReactComponent as FullscreenIcon } from 'Images/public/article-template/FullscreenIcon.svg';
import { IconButton } from 'Components/Button';


const getEnlargeLabel = (caption) => {
  const match = caption?.match(/^\s*(Figure\s+\d+)/i);
  return match ? `Enlarge ${match[1]}` : 'Enlarge image';
};



const ArticleImage = ({ src, alt, caption, className }) => {
  const [showLightbox, setShowLightbox] = useState(false);
  const closeBtnRef = useRef(null); 

    const CustomDialog = (props) => {
        console.log(props);
        return (
            <>
                <div {...props} className={`h-100 p-3 d-flex flex-column align-items-center pe-none ${props.className || ''}`}>  
                    <IconButton
                        autoFocus 
                        //ref={closeBtnRef}
                        id="Close"
                        icon={<CloseIcon aria-hidden="true" />}
                        onClick={() => setShowLightbox(false)}
                        className="article-image-lightbox-close position-relative ms-auto mt-2 pe-auto"
                    />
                    <div className="pe-none d-flex flex-column flex-grow-1 flex-shrink-1 justify-content-center zoom article-modal-img-container">
                        {props.children}
                    </div>
                </div>
            </>
        );
    };

  return (
    <Figure 
        className={`d-block article-figure${className ? ` ${className}` : ''}`}
        
    >
        <Button className="article-img-frame p-0 mb-8px" variant="" onClick={() => setShowLightbox(true)}>
            <div>
                <img src={src} alt={alt} className="article-img" />
            </div>
            <div id="enlarge-button" className={"article-img-enlarge-btn icon-button btn btn-primary"} aria-label={'enlarge-button'}>
                <div className="buttonIcon">
                    <FullscreenIcon aria-hidden="true" focusable="false" />
                </div>
            </div>
        </Button>
      {caption && <FigureCaption className="article-figcaption body bold mb-3">{caption}</FigureCaption>}

      <Modal
        show={showLightbox}
        onHide={() => setShowLightbox(false)}
        restoreFocus
        className="article-image-lightbox "
        backdropClassName="article-image-lightbox-backdrop"
        dialogClassName=""
        fade={true}
        backdrop={true}
        dialogAs={CustomDialog}
      >
        <Image fluid src={src} alt={alt} className="article-image-lightbox-img pe-auto" /> 
      </Modal>
    </Figure>
  );
};

export default ArticleImage;
